import {Component, Injector} from '@angular/core';
import {BasePageComponent} from "@core-components/page-content/base-page.component";
import {PrintApplicationService} from "@features/leads/applications/print-application/print-application.service";
import {SnackbarService} from "@ui-kit/framework/util/service/snackbar.service";
import {displayCode} from "@ui-kit/framework/util/static/string-format-util";
import {PrintDocumentInfo} from "src/app/shared/interfaces/print.interface";

@Component({
  selector: 'app-applications-view',
  templateUrl: './applications-view.component.html',
})
export class ApplicationsViewComponent extends BasePageComponent {
  retailerId!: string;
  companyName: string;

  constructor(injector: Injector,
              private _snackbar: SnackbarService,
              private _printTemplatesService: PrintApplicationService) {
    super(injector);
    this.retailerId = this.data.id;
    this.companyName = this.data.companyName;
  }

  downloadApplicationAsPdf() {
    this._snackbar.openSnackBar('Generating PDF, please wait...');
    const docId = Math.random().toString(36).substr(2, 9).toUpperCase();

    const docInfo: PrintDocumentInfo = {
      docId: docId,
      title: 'Contact Lead Form',
      subtitle: 'This applicant expressed interest in joining your curated leads pipeline.'
    }

    const customStyles = {
      customCss: `
      .page-content, .info-header {
        background-color: white !important;
      }`,
      doNotPrint: ['.mdc-button']
    }

    this._printTemplatesService.getApplicationPrint(this.retailerId, docInfo, this.offering!.uuid, customStyles)
      .then(obs => {
        obs.subscribe({
          next: (blob: Blob) => {
            console.log('PDF blob received:', blob);

            // Create a URL for the blob
            const fileURL = URL.createObjectURL(blob);

            // Create a temporary anchor element to trigger download
            const anchor = document.createElement('a');
            anchor.href = fileURL;
            anchor.download = `${displayCode(this.companyName)}_${docId}`
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);

            // Clean up the object URL
            URL.revokeObjectURL(fileURL);
          },
          error: (error: any) => {
            console.error('Error downloading PDF:', error);
            this._snackbar.openSnackBar('Error generating PDF');
          },
          complete: () => {
            console.log('Download complete');
            this._snackbar.openSnackBar('PDF downloaded successfully');
            // Raise event
            this.raiseDownloadEvent(docId);
          }
        });
      })
  }

  raiseDownloadEvent(docId: string) {
    this._printTemplatesService.raiseDownloadApplicationEvent(this.retailerId, docId).subscribe({
      next: () => {
        console.log('Successfully raised download event for docId:', docId);
      },
      error: (error: any) => {
        console.error('Error raising download event:', error);
      }
    })
  }

}
